import { BaseModal, Button, Input, Textarea, ToastMessage } from '@cokitchen/cokitchen-components';
import React, { useState } from 'react';
import { AddCircleIcon } from 'cokitchen-icons';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { isEditMeal } from 'utils/functions';
import { useLocation } from 'react-router-dom';
import { BrandOption } from 'utils/types';
import SelectBrand from 'components/select-brand';
import Tippy from '@tippyjs/react';

type Props = {
  isOpen: boolean;
  onClose: (items?: BrandOption[]) => void;
  selectedBrand: BrandOption[];
  setSelectedBrand: (item: BrandOption[]) => void;
};

export type NewCategoryDataType = {
  name: string;
  brandName: string;
  id: string;
};

const NewCategoryModal = ({ isOpen, onClose, selectedBrand, setSelectedBrand }: Props) => {
  const [categoryName, setCategoryName] = useState('');
  const [categoryDescription, setCategoryDescription] = useState('');
  const [horizontal, setHorizontal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { pathname } = useLocation();
  const createNewCategory = async () => {
    setLoading(true);
    try {
      const res = await apiService.post('meal-category', {
        data: {
          name: categoryName,
          brand_ids: selectedBrand?.map((item) => item.value),
          description: categoryDescription,
          horizontal: horizontal
        }
      });
      if (res.data) {
        toast(<ToastMessage type='success' message='Meal category created successfully' />);

        const newItems = res.data.data.map((item: any) => ({
          text: isEditMeal(pathname) ? item.name : `${item?.brand.name} - ${item.name}`,
          value: item.id
        }));

        onClose(newItems);
        setCategoryName('');
        setCategoryDescription('');
        setHorizontal(false);
      }
    } catch {
      toast(<ToastMessage type='error' message='There was a problem creating category' />);
    } finally {
      setLoading(false);
    }
  };
  const validate = selectedBrand?.length > 0;
  return (
    <BaseModal
      isOpen={isOpen}
      title=''
      onRequestClose={() => {
        onClose();
        setCategoryName('');
        setCategoryDescription('');
        setHorizontal(false);
      }}
      hasBackButton={false}
      titleIcon={<AddCircleIcon className='text-gray-5' />}
      titleIconColor='gray'>
      <div className=' flex flex-col space-y-4 '>
        <h4 className='text-center text-xl font-semibold'>New Category</h4>
        <div>
          <p className='mb-2 font-[500]'>Select brand</p>
          <SelectBrand brands={selectedBrand} setBrands={setSelectedBrand} hasSearch multiple />
        </div>
        <Input
          type='text'
          label='Category name'
          className='mt-2'
          placeholder='Category name'
          value={categoryName}
          onChange={(e) => {
            setCategoryName(e.target.value);
          }}
        />
        <div className='my-2'>
          <Textarea
            label='Category description'
            placeholder='Category description'
            rows={4}
            value={categoryDescription}
            onChange={(e) => {
              setCategoryDescription(e.target.value);
            }}
          />
        </div>

        <Tippy
          placement='bottom-start'
          content={
            <p className='z-98 bg-white border border-gray-11 p-2 shadow-lg rounded'>
              If enabled, this category will appear as a horizontal scroll section on the mobile
              app.
            </p>
          }>
          <div
            onClick={() => setHorizontal(!horizontal)}
            className='flex items-center gap-2 cursor-pointer'>
            <Input type='checkbox' name='horizontal' checked={horizontal} checkColor='gray' />
            <p className='text-sm font-medium'>Display Horizontally </p>
          </div>
        </Tippy>
        <Button
          color='primary'
          variant='block'
          small
          loading={loading}
          onClick={() => createNewCategory()}
          disabled={!validate}>
          Confirm
        </Button>
      </div>
    </BaseModal>
  );
};

export default NewCategoryModal;
